import React, { useRef, useEffect, CSSProperties } from 'react';
import ReactSelect, {
  OptionTypeBase,
  Props as SelectProps,
} from 'react-select';
import { useField } from '@unform/core';

interface Props extends SelectProps<OptionTypeBase> {
  name: string;
  containerStyle?: CSSProperties;
}

const Select: React.FC<Props> = ({ name, containerStyle, ...rest }) => {
  const selectRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  const styles = {
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: 8,
      borderColor: error ? '#e53935' : '#9e9e9e',
      color: '#9e9e9e',
      cursor: 'pointer',
      ...containerStyle,
    }),
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return [];
          }
          return ref.state.value.map((option: OptionTypeBase) => option.value);
        }
        if (!ref.state.value) {
          return '';
        }
        return ref.state.value.value;
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  return (
    <ReactSelect
      defaultValue={defaultValue}
      ref={selectRef}
      classNamePrefix="react-select"
      {...rest}
      styles={styles}
    />
  );
};

export default Select;
